/* @flow */

import * as React from 'react';

import {Stack} from 'shells/layout';

import type {
    GetSuggestedReplies_suggestedReplies as SuggestedReplies,
    GetSuggestedReplies_suggestedReplies_replies as SuggestedReply,
} from 'nutshell-graphql-types';

import {SuggestedReplyLabel, SuggestedReplyCards} from './index';

type Props = {|
    suggestedReplies: ?SuggestedReplies,
    isLoading: ?boolean,
    onCardClicked: (reply: SuggestedReply) => void,
    variant?: 'full' | 'sparse',
|};

export function SuggestedReplyContainer(props: Props) {
    return (
        <Stack spacing={8}>
            <Stack spacing={4} isHorizontal={true}>
                <SuggestedReplyLabel />
            </Stack>
            <SuggestedReplyCards
                suggestedReplies={props.suggestedReplies}
                isLoading={props.isLoading}
                onCardClicked={props.onCardClicked}
                variant={props.variant}
            />
        </Stack>
    );
}
